"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavigationBarLinkItem = exports.NavigationBarLink = exports.NavigationBarLightCTAItem = exports.NavigationBarItemContent = exports.NavigationBarItem = exports.NavigationBarContentColumn = exports.NavigationBarColumnItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _resizeObserver = _interopRequireDefault(require("@react-hook/resize-observer"));
var NavigationMenuPrimitive = _interopRequireWildcard(require("@radix-ui/react-navigation-menu"));
var Separator = _interopRequireWildcard(require("@radix-ui/react-separator"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Icon = require("../../../deprecated/atoms/Icon");
var _Accordion = _interopRequireDefault(require("./Accordion"));
var _globalTokens = require("../../shared/global-tokens");
var _jsxRuntime = require("react/jsx-runtime");
// Root menu with styles
var StyledMenu = (0, _styledComponents.default)(NavigationMenuPrimitive.Root).withConfig({
  displayName: "NavigationBar__StyledMenu",
  componentId: "sc-9epgb-0"
})(["position:relative;display:flex;align-self:flex-end;flex:1 1 auto;> div:nth-child(1){z-index:50;background-color:#ffff;}"]);
var StyledList = (0, _styledComponents.default)(NavigationMenuPrimitive.List).withConfig({
  displayName: "NavigationBar__StyledList",
  componentId: "sc-9epgb-1"
})(["all:unset;display:flex;justify-content:center;align-items:flex-end;padding:0;list-style:none;"]);
var ViewportPosition = _styledComponents.default.div.withConfig({
  displayName: "NavigationBar__ViewportPosition",
  componentId: "sc-9epgb-2"
})(["position:absolute;display:flex;left:0;top:calc(100% + ", ");width:auto;z-index:49;"], _globalTokens.globalBorder.width.thin);
var scaleOut = (0, _styledComponents.keyframes)(["from:{opacity:1},to:{opacity:0},"]);
var StyledViewport = (0, _styledComponents.default)(NavigationMenuPrimitive.Viewport).withConfig({
  displayName: "NavigationBar__StyledViewport",
  componentId: "sc-9epgb-3"
})(["position:relative;display:", ";transform:", ";&[data-state='closed']{animation:", " 10ms ease;}width:var(--radix-navigation-menu-viewport-width);height:var(--radix-navigation-menu-viewport-height);", ";background:", ";border-radius:0 0 ", " ", ";z-index:9999;"], function (_ref) {
  var offset = _ref.offset;
  return offset == null ? 'none' : '';
}, function (_ref2) {
  var offset = _ref2.offset;
  return "translateX(".concat(offset, "px)");
}, scaleOut, _globalTokens.globalShadow['2'], function (props) {
  return props.theme.sys.color.background.neutral['1'];
}, _globalTokens.globalBorder.radius['3'], _globalTokens.globalBorder.radius['3']);
var NavigationBar = function NavigationBar(_ref3) {
  var children = _ref3.children,
    onMoreClick = _ref3.onMoreClick;
  var _react$default$useSta = _react.default.useState(false),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    fontsReady = _react$default$useSta2[0],
    setFontsReady = _react$default$useSta2[1];
  var _react$default$useSta3 = _react.default.useState(),
    _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
    offset = _react$default$useSta4[0],
    setOffset = _react$default$useSta4[1];
  var _react$default$useSta5 = _react.default.useState([]),
    _react$default$useSta6 = _slicedToArray(_react$default$useSta5, 2),
    childWidths = _react$default$useSta6[0],
    setChildWidths = _react$default$useSta6[1];
  var _react$default$useSta7 = _react.default.useState(999),
    _react$default$useSta8 = _slicedToArray(_react$default$useSta7, 2),
    lastShownChildIndex = _react$default$useSta8[0],
    setLastShownChildIndex = _react$default$useSta8[1];
  var menuRef = _react.default.useRef();
  var listRef = _react.default.useRef();
  var _react$default$useSta9 = _react.default.useState(),
    _react$default$useSta10 = _slicedToArray(_react$default$useSta9, 2),
    value = _react$default$useSta10[0],
    setValue = _react$default$useSta10[1];
  var _react$default$useSta11 = _react.default.useState(),
    _react$default$useSta12 = _slicedToArray(_react$default$useSta11, 2),
    activeTrigger = _react$default$useSta12[0],
    setActiveTrigger = _react$default$useSta12[1]; // Triggers when menuRef changes size. Calculates how many manu items we can fit and stores the index of the last shown menu item in lastShownChildIndex.
  var resizeCallback = (0, _react.useCallback)(function (entry) {
    if (!fontsReady) return; // Check if the font for the header has been loaded before calculating widths
    var currentChildWidths = childWidths;
    if (childWidths.length === 0) {
      currentChildWidths = Array.from(listRef.current.children).map(function (item) {
        return item.getBoundingClientRect().width;
      });
      setChildWidths(currentChildWidths);
    }
    var totalChildWidth = currentChildWidths.reduce(function (prev, current) {
      return prev + current;
    }, 0);
    var containerWidth = entry.contentRect.width;
    var buffer = 5; // Number of pixels between child widths and container width before breaking,
    if (totalChildWidth >= containerWidth) {
      var childWidthSum = 0;
      var childIndex = 0;
      for (var i = 0; i < children.length; i++) {
        childWidthSum += childWidths[i];
        if (childWidthSum + buffer >= containerWidth) {
          break;
        }
        childIndex = i;
      }
      if (lastShownChildIndex !== childIndex - 1) {
        setLastShownChildIndex(childIndex - 1);
      }
    } else if (lastShownChildIndex < children.length - 1) {
      setLastShownChildIndex(children.length - 1);
    }
  }, [childWidths, children, lastShownChildIndex, fontsReady]);
  (0, _resizeObserver.default)(menuRef, resizeCallback);
  _react.default.useEffect(function () {
    document.fonts.ready.then(function () {
      setFontsReady(true);
    });
  }, []);
  _react.default.useEffect(function () {
    var list = listRef.current;
    if (activeTrigger && list) {
      setOffset(Math.round(activeTrigger.offsetLeft));
    } else if (value === '') {
      setOffset(null);
    }
  }, [activeTrigger, value]);

  // Trigger resizeCallback once fonts have been loaded
  _react.default.useEffect(function () {
    resizeCallback({
      contentRect: menuRef.current.getBoundingClientRect()
    });
  }, [resizeCallback, fontsReady]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledMenu, {
    value: value,
    onValueChange: setValue,
    ref: menuRef,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledList, {
      ref: listRef,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [_react.default.Children.map(children, function (child, index) {
          if (index <= lastShownChildIndex) {
            // Checking isValidElement is the safe way and avoids a
            // typescript error too.
            if ( /*#__PURE__*/_react.default.isValidElement(child)) {
              return /*#__PURE__*/_react.default.cloneElement(child, {
                triggerProps: {
                  activeTrigger: activeTrigger,
                  setActiveTrigger: setActiveTrigger,
                  value: value
                }
              });
            }
            return child;
          }
          return null;
        }), children.length > lastShownChildIndex + 1 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(NavigationBarItem, {
          name: lastShownChildIndex < 0 ? 'Menu' : 'More',
          isActive: false,
          triggerProps: {
            activeTrigger: activeTrigger,
            setActiveTrigger: setActiveTrigger,
            value: value
          },
          onClick: onMoreClick,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledContent, {
            onPointerLeave: function onPointerLeave(event) {
              return event.preventDefault();
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Accordion.default, {
              children: cloneChildrenForAccordion(children, lastShownChildIndex + 1)
            })
          })
        }) : null]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ViewportPosition, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledViewport, {
        offset: offset
      })
    })]
  });
};
var topItemStyle = function topItemStyle() {
  return (0, _styledComponents.css)(["all:unset;position:relative;display:flex;align-items:center;justify-content:space-between;gap:", ";cursor:pointer;padding:10px ", " ", " ", ";border-style:solid;border-color:transparent;border-width:", " ", " 0 ", ";border-radius:", " ", " 0 0;", ";color:", ";white-space:nowrap;&:focus-visible{border-color:", ";}&:hover{background:", ";}&:active{background:", ";}&[data-active='true']{color:", ";}"], _globalTokens.globalSpacing['200'], _globalTokens.globalSpacing['300'], _globalTokens.globalSpacing['400'], _globalTokens.globalSpacing['300'], _globalTokens.globalBorder.width.thick, _globalTokens.globalBorder.width.thick, _globalTokens.globalBorder.width.thick, _globalTokens.globalBorder.radius['2'], _globalTokens.globalBorder.radius['2'], function (props) {
    return props.theme.sys.font.body['1'];
  }, function (props) {
    return props.theme.sys.color.text.content.main;
  }, function (props) {
    return props.theme.sys.color.border.focusring;
  }, function (props) {
    return props.theme.comp.button.color.background.midemphasis.hover;
  }, function (props) {
    return props.theme.comp.button.color.background.midemphasis.pressed;
  }, function (props) {
    return props.theme.sys.color.text.content.primary;
  });
};

// Item with styles
// Note that in order to render the theme correctly the css functions must be called through an anonymous function
// Otherwise it will be cached before the theme is set
var StyledLinkItem = (0, _styledComponents.default)(NavigationMenuPrimitive.Link).withConfig({
  displayName: "NavigationBar__StyledLinkItem",
  componentId: "sc-9epgb-4"
})(["", ""], function () {
  return topItemStyle();
});
var StyledTrigger = (0, _styledComponents.default)(NavigationMenuPrimitive.Trigger).withConfig({
  displayName: "NavigationBar__StyledTrigger",
  componentId: "sc-9epgb-5"
})(["", ""], function () {
  return topItemStyle();
});
var ActiveIndicator = _styledComponents.default.div.withConfig({
  displayName: "NavigationBar__ActiveIndicator",
  componentId: "sc-9epgb-6"
})(["position:absolute;left:-", ";right:-", ";bottom:0;height:", ";&[data-active='true']{background:", ";}"], _globalTokens.globalBorder.width.thick, _globalTokens.globalBorder.width.thick, _globalTokens.globalSizing['100'], function (props) {
  return props.theme.sys.color.border.active;
});
var StyledCaret = (0, _styledComponents.default)(_Icon.Icon).withConfig({
  displayName: "NavigationBar__StyledCaret",
  componentId: "sc-9epgb-7"
})(["[data-state='open'] &{transform:rotate(-180deg);path{fill:", ";}}"], function (props) {
  return props.theme.sys.color.iconfill.primary;
});
var NavigationBarItem = function NavigationBarItem(_ref4) {
  var children = _ref4.children,
    triggerProps = _ref4.triggerProps,
    name = _ref4.name,
    isActive = _ref4.isActive,
    isAccordion = _ref4.isAccordion,
    onClick = _ref4.onClick,
    dataCy = _ref4['data-cy'];
  if (isAccordion) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Accordion.default.Item, {
      onClick: onClick,
      name: name,
      "data-cy": dataCy,
      children: cloneChildrenForAccordion(children)
    });
  } else {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(NavigationMenuPrimitive.Item, {
      value: name,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledTrigger, {
        onClick: onClick,
        onPointerMove: function onPointerMove(event) {
          return event.preventDefault();
        },
        onPointerLeave: function onPointerLeave(event) {
          return event.preventDefault();
        },
        ref: function ref(node) {
          if (name === triggerProps.value && triggerProps.activeTrigger !== node) {
            triggerProps.setActiveTrigger(node);
          }
          return node;
        },
        "data-active": isActive,
        "data-cy": dataCy,
        children: [name, /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCaret, {
          icon: 'chevronDown',
          size: 'm',
          "aria-hidden": true
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ActiveIndicator, {
          "data-active": isActive,
          "aria-hidden": true
        })]
      }), children]
    }, name);
  }
};
exports.NavigationBarItem = NavigationBarItem;
var NavigationBarLinkItem = function NavigationBarLinkItem(_ref5) {
  var children = _ref5.children,
    isAccordion = _ref5.isAccordion,
    isActive = _ref5.isActive,
    href = _ref5.href,
    props = _objectWithoutProperties(_ref5, ["children", "isAccordion", "isActive", "href"]);
  if (isAccordion) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Accordion.default.Link, _objectSpread({
      href: href
    }, props, {
      children: children
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(NavigationMenuPrimitive.Item, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledLinkItem, _objectSpread({
      href: href
    }, props, {
      children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(ActiveIndicator, {
        "data-active": isActive,
        "aria-hidden": true
      })]
    }))
  });
};

// Item content / dropdown with styles
exports.NavigationBarLinkItem = NavigationBarLinkItem;
var StyledContent = (0, _styledComponents.default)(NavigationMenuPrimitive.Content).withConfig({
  displayName: "NavigationBar__StyledContent",
  componentId: "sc-9epgb-8"
})(["position:absolute;top:0;left:0;width:auto;max-height:calc(100vh - 56px);overflow:auto;"]);
var StyledContentColumn = _styledComponents.default.ul.withConfig({
  displayName: "NavigationBar__StyledContentColumn",
  componentId: "sc-9epgb-9"
})(["box-sizing:border-box;list-style:none;padding:0;margin:0;"]);
var ContentGrid = _styledComponents.default.ul.withConfig({
  displayName: "NavigationBar__ContentGrid",
  componentId: "sc-9epgb-10"
})(["display:grid;list-style:none;margin:0;padding:", ";column-gap:", ";grid-auto-flow:column;"], _globalTokens.globalSpacing['300'], _globalTokens.globalSpacing['300']);
var VerticalSeparator = (0, _styledComponents.default)(Separator.Root).withConfig({
  displayName: "NavigationBar__VerticalSeparator",
  componentId: "sc-9epgb-11"
})(["height:100%;width:", ";background:", ";"], _globalTokens.globalSizing['25'], function (props) {
  return props.theme.sys.color.border.decorative;
});
var HorizontalSeparator = (0, _styledComponents.default)(Separator.Root).withConfig({
  displayName: "NavigationBar__HorizontalSeparator",
  componentId: "sc-9epgb-12"
})(["width:calc(100% + ", ");height:", ";background:", ";margin:", " 0;"], _globalTokens.globalSizing['300'], _globalTokens.globalSizing['25'], function (props) {
  return props.theme.sys.color.border.decorative;
}, _globalTokens.globalSpacing['300']);
var NavigationBarItemContent = function NavigationBarItemContent(_ref6) {
  var children = _ref6.children,
    isAccordion = _ref6.isAccordion;
  return isAccordion ? cloneChildrenForAccordion(children) : /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledContent, {
    onPointerLeave: function onPointerLeave(event) {
      return event.preventDefault();
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ContentGrid, {
      children: _react.default.Children.map(children, function (column, i) {
        if (i === 0 || column == null) {
          return column;
        }
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(VerticalSeparator, {}), column]
        });
      })
    })
  });
};

// Content item with styles
exports.NavigationBarItemContent = NavigationBarItemContent;
var StyledLink = (0, _styledComponents.default)(NavigationMenuPrimitive.Link).withConfig({
  displayName: "NavigationBar__StyledLink",
  componentId: "sc-9epgb-13"
})(["text-decoration:none;text-transform:capitalize;white-space:nowrap;min-width:200px;display:flex;align-items:center;border-radius:", ";padding:6px ", " 6px ", ";", ";border-width:", ";border-style:solid;border-color:transparent;color:", ";&:focus-visible{outline:none;border-color:", ";}&:hover{background:", ";}"], function (props) {
  return props.theme.sys.size.borderradius.focusring;
}, _globalTokens.globalSpacing['300'], _globalTokens.globalSpacing['300'], function (props) {
  return props.theme.sys.font.body['1'];
}, _globalTokens.globalBorder.width.thick, function (props) {
  return props.theme.sys.color.text.content.main;
}, function (props) {
  return props.theme.sys.color.border.focusring;
}, function (props) {
  return props.theme.sys.color.background.primary['1'];
});
var StyledColumnItem = _styledComponents.default.li.withConfig({
  displayName: "NavigationBar__StyledColumnItem",
  componentId: "sc-9epgb-14"
})(["> a:hover{color:", ";}"], function (props) {
  return props.theme.sys.color.text.content.main;
});
var NavigationBarColumnItem = function NavigationBarColumnItem(_ref7) {
  var children = _ref7.children,
    isAccordion = _ref7.isAccordion;
  return isAccordion ? cloneChildrenForAccordion(children) : /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledColumnItem, {
    children: children
  });
};
exports.NavigationBarColumnItem = NavigationBarColumnItem;
var NavigationBarLightCTAItem = function NavigationBarLightCTAItem(_ref8) {
  var lightCTAItem = _ref8.children,
    isAccordion = _ref8.isAccordion;
  return isAccordion ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Accordion.default.Separator, {
      orientation: "horizontal",
      decorative: true
    }), cloneChildrenForAccordion(lightCTAItem)]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(HorizontalSeparator, {
      orientation: "horizontal",
      decorative: true
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledColumnItem, {
      children: lightCTAItem
    })]
  });
};
exports.NavigationBarLightCTAItem = NavigationBarLightCTAItem;
var NavigationBarLink = function NavigationBarLink(_ref9) {
  var children = _ref9.children,
    href = _ref9.href,
    isAccordion = _ref9.isAccordion,
    props = _objectWithoutProperties(_ref9, ["children", "href", "isAccordion"]);
  return isAccordion ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Accordion.default.Link, _objectSpread({
    href: href
  }, props, {
    children: children
  })) : /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLink, _objectSpread({
    href: href
  }, props, {
    children: children
  }));
};
exports.NavigationBarLink = NavigationBarLink;
var NavigationBarContentColumn = function NavigationBarContentColumn(_ref10) {
  var children = _ref10.children,
    isAccordion = _ref10.isAccordion;
  return isAccordion ? cloneChildrenForAccordion(children) : /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledContentColumn, {
    children: children
  });
};

/**
 * Clones an array of children and adds the isAccordion: true prop
 * @param 	{React.ReactNode}	children	The children of a react component we want cloned
 * @param 	{Number}			minIndex	Optional integer. Only clone the children who's index is greater or equal to minIndex.
 * @returns {React.ReactNode} 				The cloned children with an added isAccordion: true prop
 */
exports.NavigationBarContentColumn = NavigationBarContentColumn;
var cloneChildrenForAccordion = function cloneChildrenForAccordion(children, minIndex) {
  return _react.default.Children.map(children, function (child, index) {
    if (minIndex != null && index < minIndex) return null;
    if (! /*#__PURE__*/_react.default.isValidElement(child)) return child;
    return /*#__PURE__*/_react.default.cloneElement(child, {
      isAccordion: true
    });
  });
};

// ONLY USED FOR STORYBOOK DOCUMENTATION

NavigationBar.Link = NavigationBarLink;
NavigationBar.Item = NavigationBarItem;
NavigationBar.LinkItem = NavigationBarLinkItem;
NavigationBar.ItemContent = NavigationBarItemContent;
NavigationBar.ContentColumn = NavigationBarContentColumn;
NavigationBar.ColumnItem = NavigationBarColumnItem;
NavigationBar.LightCTAItem = NavigationBarLightCTAItem;
var _default = exports.default = NavigationBar;